import { Component, OnInit, OnDestroy, Output, Input, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { LogEntryPhoto } from '../../../../../models/logs/photos/LogEntryPhoto.interface';
import { ScreenSizeService } from '../../../../../service/screen-size.service';
import { PhotoService } from '../../../../../service/photo.service';
import { Subscription } from 'rxjs';
import { PhotoMetadata } from '../../../../../models/logs/photos/PhotoMetadata';
import { copyPhotosToClipboard } from '../../../../../helpers/copy-photos';
import { DataLoading } from '../../../../../models/DataLoading.interface';
import { AssetsDataService } from '../../../../../service/assets-data.service';

/**
 * Minimal structural shape the grid needs — satisfied by LogEntryPhoto,
 * PhotoMetadata, and SofPhotoMetadata alike (same approach as the
 * photo-viewer-modal's PhotoType).
 */
interface PhotoType {
  id: string | number;
  url: string;
  name?: string;
  blobName?: string;
  /** What the photo is of (e.g. 'Slip'); shown on the thumbnail when present. */
  kind?: string;
}

@Component({
  selector: 'app-photo-grid-viewer',
  templateUrl: './photo-grid-viewer.component.html',
  styleUrls: ['./photo-grid-viewer.component.css']
})
export class PhotoGridViewerComponent implements OnInit, OnDestroy, OnChanges {
  @Output() deletePhoto: EventEmitter<number> = new EventEmitter<number>();
  @Output() deleteAllPhotos: EventEmitter<void> = new EventEmitter<void>();
  @Input() includeCopyPhotos: boolean = false;
  @Input() photosEditable: boolean = true;
  @Input() viewingLogRow: boolean = false;
  @Input() photos: PhotoType[] = [];
  /**
   * Optional label stamped on every thumbnail (e.g. "Not saved yet" vs
   * "Saved" when a host shows pending and persisted photos side by side).
   */
  @Input() badgeText: string = '';
  /** Ionic color of the badge (only used when badgeText is set). */
  @Input() badgeColor: string = 'primary';
  /**
   * Stamps each thumbnail with its photo's `kind`. For hosts showing one mixed
   * grid; a host that splits the photos into a grid per kind labels the headings
   * instead and leaves this off.
   */
  @Input() showKindLabels: boolean = false;


  private dataLoadingSubscription!: Subscription;
  public isMobile: boolean = false;
  public dataLoading: DataLoading = { isLoading: false, message: '' };



  public isPhotoModalOpen: boolean = false;
  public selectedPhotoIndex: number = 0;
  public minPhotos: number = 3;

  private newLogPhotoSubscription!: Subscription;
  private logRowPhotoSubscription!: Subscription;

  constructor(
    private _screenSizeService: ScreenSizeService,
    private _photoService: PhotoService,
    private _assetsDataService: AssetsDataService

  ) {
  }

  ngOnInit(): void {
    this.isMobile = this._screenSizeService.isMobile.getValue();
    this.dataLoadingSubscription = this._photoService.dataLoading.subscribe((dataLoading: DataLoading) => {
      this.dataLoading = dataLoading;
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['photos']) {
      const photos = changes['photos'].currentValue;
      this.photos = photos;
      console.log('photos in photo grid viewer', photos);
    }
  }

  ngOnDestroy(): void {
this.dataLoadingSubscription.unsubscribe();
  }

  copyPhotos(): void {
    copyPhotosToClipboard(this.photos as LogEntryPhoto[], 'Photos copied to clipboard!', this.isMobile);
  }


  onDeletePhoto(index: number): void {
    this.deletePhoto.emit(index);
  }

  onDeleteAllPhotos(): void {
    this.deleteAllPhotos.emit();
  }

  onOpenPhotoModal(index: number): void {
    this.selectedPhotoIndex = index;
    this.isPhotoModalOpen = true;
  }

  closePhotoModal(): void {
    this.isPhotoModalOpen = false;
  }
}
